import axios from '@/CommonDP/utils/request';

export const getVfDictList = (params) => axios('dic/list', { params });
export const getVfDictItems = (params) => axios('dic/item/list', { params });
export const getVfDictAdd = (data) => axios({
  data,
  method: 'post',
  url: 'dic/item/batch-add'
});
export const getSysAreaList = (params) => axios({
  params,
  url: 'sys-area/list'
});
export const getFileInfoByFileIdAndVersion = (data) => axios({
  data,
  method: 'post',
  url: 'doc/getFileInfoByFileIdAndVersion'
});
